"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const styleOverrides = {
  root: {
    color: _constants.colors.defaultColors.dark,
    '&:hover': {
      backgroundColor: _constants.colors.oriGrey[100]
    },
    [`&.${_material.checkboxClasses.checked}`]: {
      color: _constants.colors.defaultColors.dark
    },
    [`&.${_material.checkboxClasses.checked}.${_material.checkboxClasses.disabled}`]: {
      color: _constants.colors.oriGrey[400]
    }
  }
};
const defaultProps = {
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxEmpty, {}),
  indeterminateIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxIndeterminate, {}),
  checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxChecked, {}),
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiCheckbox.js.map